// src/app/utils/validation.utils.ts
export class ValidationUtils {

  static isValidEmail(email: string | undefined | null): boolean {
    if (!email || email.trim() === '') return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email.trim());
  }
  static hasValue(value: string | undefined | null): boolean {
    return value?.trim() ? true : false;
  }
  static isValidPhone(phone: string | undefined | null): boolean {
    if (!phone) return false;

    const phoneStr = phone.trim();
    if (phoneStr === '') return false;
    const allowedPhoneRegex = /^[0-9+\-() .\s]*$/;

    if (!allowedPhoneRegex.test(phoneStr)) {
      return false
    }
    const digitsOnly = phoneStr.replace(/\D/g, '');
    return digitsOnly.length >= 8 && digitsOnly.length <= 25;
  }
static announceAlertSuccess(message: string) {
  const liveRegion = document.getElementById('liveRegionLoginStatus');
  if (liveRegion) {
    liveRegion.textContent = '';
    setTimeout(() => {
      liveRegion.textContent = message;
    }, 100);
  }
}
}
